import RequireAdmin from "../components/hoc/RequireAdmin";
import RequireAuth from "../components/hoc/RequireAuth";
import RootLayout from "../components/layout/RootLayout";
import useInjectSidebar from "../hooks/useInjectSidebar";
import UserDashboard from "../pages/admin-area/overview/users/UserDashboard";
import GroupDashboard from "../pages/admin-area/overview/groups/GroupDashboard";
import OverviewDashboard from "../pages/admin-area/overview/dashboard/OverviewDashboard";
import AdminGroupViewer from "../pages/admin-area/management/groups/AdminGroupViewer";
import CreateNewGroup from "../pages/admin-area/management/groups/CreateNewGroup";

const Layout = () => useInjectSidebar({ sidebarName: "admin" })(RootLayout);

export const adminAreaRoute = {
    path: "/admin",
    element: (
        <RequireAuth>
            <RequireAdmin>
                <Layout />
            </RequireAdmin>
        </RequireAuth>
    ),
    children: [
        {
            index: true,
            element: <OverviewDashboard />,
        },
        {
            path: "users",
            element: <UserDashboard />,
        },
        {
            path: "users/:userId",
            element: <div>user by id</div>,
        },
        {
            path: "groups",
            element: <GroupDashboard />,
        },
        {
            path: "groups/:groupId",
            element: <AdminGroupViewer />,
        },
        {
            path: "groups/new",
            element: <CreateNewGroup />,
        },
        {
            path: "organization-chart",
            element: <div>org chart</div>,
        },
        {
            path: "workspace",
            element: <div>workspace</div>,
        },
        {
            path: "*",
            element: <div>404 DATA NOT FOUND.</div>,
        },
    ],
};
